import { ADMIN_ROLES } from "../auth";

export const routes = {
    "/genericCaseTypes": {
        title: "Generic Case Types",
        authorize: [ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name],
        "/create": {
            title: "Create",
            authorize: [ADMIN_ROLES.SYSTEM_ADMIN.name]
        },
        "/:genericCaseTypeId": {
            title: "Details",
            "/edit": {
                title: "Edit",
                authorize: [ADMIN_ROLES.SYSTEM_ADMIN.name]
            }
        }
    }
};
